import { defaultReadTextDeps, type ReadTextDeps } from "./read-file-text";

/** 利用者が選んだ（またはドロップした）説明ファイルの読み取り結果。 */
export type SelectedMarkdownFile =
  | {
      readonly kind: "ok";
      readonly fileName: string;
      readonly contents: string;
    }
  /** 拡張子が .md ではない。 */
  | { readonly kind: "not-markdown"; readonly fileName: string }
  /** ファイルを読めなかった（権限・破損など）。 */
  | { readonly kind: "unreadable"; readonly fileName: string };

/**
 * 説明（Markdown）のファイルを読む。
 *
 * 選んだファイルの名前は保存名にしない（説明は常に README.md）ので、名前は
 * 拡張子を見るためと表示のためにだけ使う。拡張子はここで見る（file-drop-zone は
 * ドロップを絞らない）。
 */
export async function readMarkdownFile(
  file: File,
  deps: ReadTextDeps = defaultReadTextDeps,
): Promise<SelectedMarkdownFile> {
  if (!file.name.toLowerCase().endsWith(".md")) {
    return { kind: "not-markdown", fileName: file.name };
  }

  try {
    return {
      kind: "ok",
      fileName: file.name,
      contents: await deps.readText(file),
    };
  } catch {
    return { kind: "unreadable", fileName: file.name };
  }
}
